import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Api} from "../../services/api";

/**
 * Generated class for the MwebPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "mweb",
})
@Component({
  selector: 'page-mweb-pay',
  templateUrl: 'mweb-pay.html',
})
export class MwebPayPage {
  data = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, public api: Api) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MwebPayPage');
    this.api.mWebPay({}).then(data => {
      window.location.href = data.url;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/mweb-pay/mweb-pay.ts